import {
  isLocalhostHostname,
  isTestHostname,
} from '@storebrand-digital/insurance-common';

import { Brand, PartnerUrl, Union } from '../themes.types';
import {
  AKA_UNION_TO_LOGO_FILE_NAME_MAP,
  storebrandFooterAddon,
  storebrandLogo,
} from './partnerTheme.constants';
import { BrandLogo, Cooperation, FooterAddon } from './partnerTheme.types';

export const getAkaLogoUrl = (union: Union | undefined): string | undefined => {
  if (!union) {
    return undefined;
  }

  const logoFileName = AKA_UNION_TO_LOGO_FILE_NAME_MAP[union];
  return `${window.env.LOGOS_BASE_URL}/${logoFileName}`;
};

export const getNavbarLogo = (brand: Brand): BrandLogo | null => {
  switch (brand) {
    case 'akademikerne':
    case 'danskeBank':
    case 'coop':
      return storebrandLogo;
    default:
      return null;
  }
};

export const akademikerneCooperation = (akaLogo: string): Cooperation => {
  return {
    organization: 'Akademikerne',
    logo: {
      src: akaLogo,
      height: '24px',
    },
  };
};

export const getFooterAddon = (brand: Brand): FooterAddon | null => {
  switch (brand) {
    case 'akademikerne':
    case 'danskeBank':
      return storebrandFooterAddon;
    case 'coop':
    default:
      return null;
  }
};

export const externalLink = (path: string): string => {
  if (isTestHostname() || isLocalhostHostname()) {
    return `https://www-t.storebrand.no/${path}`;
  }
  return `https://www.storebrand.no/${path}`;
};

export const checkIsPartnerBrand = (currentBasename: string): boolean =>
  currentBasename === PartnerUrl.AKADEMIKERNE ||
  currentBasename === PartnerUrl.COOP ||
  currentBasename === PartnerUrl.DANSKE_BANK;
